// extracted by mini-css-extract-plugin
export var label = "_de-1";
export var reminder = "_de-0";